<template>
  <section class="signin-page" v-loading="isLoading">
    <div class="middle-box">
      <div class="logo">
        <img src="../assets/hermes_svg.svg" alt="">
      </div>
      <div class="signin">
        <el-form :rules="rules" ref="form" :model="signin" label-position="left" label-width="120px">
          <el-form-item @keyup.enter.native="submitForm('form')"   class="input" :label="$t('login.account')" prop="account">
            <el-input v-model="signin.account"></el-input>
          </el-form-item>
          <el-form-item @keyup.enter.native="submitForm('form')"   class="input" :label="$t('login.pwd')" prop="password">
            <el-input :type="passw"  v-model="signin.password">
              <i slot="suffix" :class="icon" @click="showPass"></i>
            </el-input>
          </el-form-item>
          <el-form-item class="button">
            <el-button type="primary" @click="submitForm('form')">{{$t('login.login')}}</el-button>
            <a href="/saml/login" class="sso-login">{{$t('login.sso_login')}}</a>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </section>
</template>
<script>
  import './Unauthorized.css'
  import {
    mapState,
    mapActions
  } from 'vuex'
  export default {
    name: 'signin',
    data() {
      return {
        isLoading:false,
        passw:"password",
        icon: "el-input__icon el-icon-view",
        signin: {
          account: '',
          password: '',
          remember: true
        },
        rules: {
          account: [{
            required: true,
            message: this.$t('login.accountRequiredMsg'),
            trigger: 'blur'
          }],
          password: [{
            required: true,
            message: this.$t('login.pwdRequiredMsg'),
            trigger: 'blur'
          }]
        }
      }
    },
    computed: {
      ...mapState(["userinfo"]),
    },
    mounted() {
      if (this.$route.query.from == 'sso') {
        this.isLoading=true
        this.initInfo().catch((errorCode) => {
          if (errorCode < 200 || errorCode >= 1000) {
              this.isLoading=false
          }
        })
      } 
    },
    watch: {
      userinfo: {
        handler(newName, oldName) {
          if(newName.username && this.$route.query.from == 'sso'){
            this.isLoading=false
            if(newName.adminlevel==2){
              this.$router.push('/order')
            }else if(newName.adminlevel==3){
              this.$router.push('/vechainorder')
            }else if(newName.adminlevel==4){
              this.$router.push('/order')
            }else{
              this.$router.push('/')
            }
          }
        },
        immediate: true
      }
    },
    methods: {
      ...mapActions(['login', 'initInfo']),
      showPass() {
        //点击图标是密码隐藏或显示
        if (this.passw == "text") {
          this.passw = "password";
          //更换图标
          this.icon = "el-input__icon el-icon-view";
        } else {
          this.passw = "text";
          this.icon = "el-input__icon el-icon-loading";
        };
      },
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
           this.isLoading=true
          if (valid) {
            this.login({
              username: this.signin.account,
              password: this.signin.password
            }).then(res => {
              this.isLoading=false
              if (this.userinfo.changepwd) {
                this.$alert(this.$t('login.reset_password'), '', {
                  confirmButtonText: this.$t('common.confirm'),
                  callback: action => {
                    this.$router.push('/changepassword')
                  }
                });
              } else {
                if(this.userinfo.adminlevel==2){
                  this.$router.push('/order')
                }else if(this.userinfo.adminlevel==3){
                  this.$router.push('/vechainorder')
                }else if(this.userinfo.adminlevel==4){
                  this.$router.push('/order')
                }else{
                  this.$router.push('/')
                }
                
              }
            })
            .catch((errorCode) => {
              this.isLoading=false
              // if (errorCode < 200 || errorCode >= 1000) {
              //   const confirm = this.$t('common.confirm')
              //   const title = this.$t('user.alert')
              //   this.$alert(this.$t(`error.error${errorCode}`), title, {
              //     confirmButtonText: confirm
              //   })
              // }
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Unauthorized.vue?4ec47656